import { type FC } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@onshopfront/components";
import { Logo } from "./Logo";
import { User } from "./User";

export const Navigation: FC = () => {
    return (
        <nav
            className={
                "w-screen overflow-hidden box-border flex justify-between whitespace-nowrap pr-4 space-x-6 shadow-lg"
            }
        >
            <Logo />
            <Link
                to="/documentation"
                className="block text-neutral text-neutral-100 no-underline hover:underline ml-2"
            >
                <Icon
                    icon={[ "fal", "book" ]}
                    className="mr-2"
                />
                Documentation
            </Link>
            <Link
                to="/applications"
                className="block text-neutral text-neutral-100 no-underline hover:underline"
            >
                <Icon
                    icon={[ "fal", "code" ]}
                    className="mr-2"
                />
                Applications
            </Link>
            <Link
                to="/partner"
                className="block text-neutral text-neutral-100 no-underline hover:underline"
            >
                <Icon
                    icon={[ "fal", "hat-cowboy" ]}
                    className="mr-2"
                />
                Partner Program
            </Link>
            <User />
        </nav>
    );
};
